// extracted by mini-css-extract-plugin
export default {"socialPlatforms":"SocialPlatforms_socialPlatforms__wNbgp"};